import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { ExpandablePanel } from '../components/widgets';
import parentCss from '../partnerConfiguration/components/shelf/PartnerConfigurationShelf.css';
import css from './CollapsableRow.css';

const CollapsableHeader = ({ title, expanded }) => {
    return (
        <div className={classnames(css.collapsableContainer, { [css.expanded]: expanded })}>
            <div>
                <div className={parentCss.title}>{title}</div>
            </div>
            <div className={css.arrowArea}>
                <ArrowDownIcon className={css.overrideArrow} />
            </div>
        </div>
    );
};

CollapsableHeader.propTypes = {
    title: PropTypes.element,
    expanded: PropTypes.bool,
};

const CollapsableRow = ({ title, children, expanded, onClick }) => (
    <ExpandablePanel
        expanded={expanded}
        content={children}
        overrideClasses={{
            container: css.overrideContainer,
            contentArea: css.panelContent,
            headerContainer: css.panelHeader,
            headerContainerExpanded: css.panelHeaderExpanded,
            arrowArea: css.overrideOldArrowArea,
            externalHeaderArea: css.expandableOverrideExternal,
            arrow: css.overrideArrow,
        }}
        dataTestId="expandablePanel"
        header={<CollapsableHeader title={title} expanded={expanded} />}
        onExpandClick={onClick}
        animate
    />
);

CollapsableRow.propTypes = {
    title: PropTypes.element,
    onClick: PropTypes.func,
    expanded: PropTypes.bool,
    children: PropTypes.element,
};

export default CollapsableRow;
